import { v4 as uuidv4 } from "uuid";
import Cookies from "js-cookie";
import {
  csrfTokenCookieName,
  fbPixelCookieName,
  fbClickIdCookieName,
} from "services/shared/CookieNames";
import { isDevEnvironment } from "services/shared/Environment";
import {
  developmentCookieDomain,
  jgntCookieDomain,
  juggernautCookieDomain,
} from "services/shared/CookieDomains";

export function setNewCsrfTokenCookie() {
  Cookies.set(csrfTokenCookieName, uuidv4(), {
    domain: getCookieDomain(),
    sameSite: isDevEnvironment() ? null : "strict",
    path: "/",
    secure: isDevEnvironment() ? false : true,
  });
}

export function getCsrfTokenCookie() {
  return Cookies.get(csrfTokenCookieName);
}

function userIsVisitingJgntDomain() {
  if (typeof window === "undefined") return false;
  return window.location.hostname?.includes("jgnt.co");
}

function getCookieDomain() {
  if (isDevEnvironment()) return developmentCookieDomain;
  if (userIsVisitingJgntDomain()) {
    return jgntCookieDomain;
  } else {
    return juggernautCookieDomain;
  }
}
